module.exports = __webpack_public_path__ + "img/whimsey-necklace-3.7c2059c0.jpg";